import styled from 'styled-components';

export const ThreadContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
  border-radius: ${({ theme }) => theme.spacing(2)}px;
`;

export const EmptyState = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.on[600]};
  padding: ${({ theme }) => theme.spacing(2)}px;
`;
